import {
  ControlcenterMelcoControlCenterModelsForwardLinkListItem,
  UrlForwardsApi,
  useAPIQuery,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";
import { UrlForwardListFiltersType } from "./UrlForwardFilterType";

export const useUrlForward = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<
    ControlcenterMelcoControlCenterModelsForwardLinkListItem,
    UrlForwardListFiltersType
  >({
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });

  //const baseApiConfig = useBaseAPIConfig();
  const query = useAPIQuery(
    UrlForwardsApi,
    ["urlForwarding", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api) => {
      //const api = new LinkForwardingApi(baseApiConfig({ token }));
      console.log({ filters, currentPage, pageSize });
      let response;
      //if (filters?.searchText && !isEmpty(filters.searchText)) {
      response = await api.urlForwardsGetList({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        // searchText:
        //     filters?.searchText && !isEmpty(filters.searchText)
        //         ? filters.searchText
        //         : '',
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
      });
      setTotal(response?.total ? response?.total : 0);
      //}

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
